var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"0.1.0"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

import pkg from "./package.json";
import { sessionId } from "./src/utils/sessionId";

Sentry.init({
  dsn: "https://fdb9cad7fbcf4a1b807374424c9b0283@o112361.ingest.sentry.io/6524036",
  tracesSampleRate: 1,
  environment: process.env.NEXT_PUBLIC_APP_ENV,
  enabled: process.env.NEXT_PUBLIC_APP_ENV !== "local",
  release: pkg.version,
});

Sentry.setTag("Running on", "Client");
Sentry.setTag("sessionId", sessionId);
